import ChatAgentOptionComAI from '../COMAI/ChatAgentOptionComAI';
import ChatAgentOptionZowie from '../zowie/ChatAgentOptionZowie';

export default function ChatAgentOptionRenderer({ options }: { options: string[] }) {
    return options.map((option) => {
        switch (option) {
            case 'comai':
                return <ChatAgentOptionComAI key={option} />;
            case 'customersupport':
                return <ChatAgentOptionZowie key={option} />;
            default:
                return null;
        }
    });
}
